(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bulletpoint-blocks"] && !Shopify.designMode) return;
  try {
    

 	const prevButton = document.querySelector("#bulletpoint-block-prev-btn");
    const nextButton = document.querySelector("#bulletpoint-block-next-btn");
    const slider = document.querySelector(".bulletpoint-blocks-container");

    let currentScrollLeft = slider.scrollLeft; 
    const firstChildWidth = slider.children[0].offsetWidth;
    const marginBetweenElement = 25;

    nextButton.addEventListener("click", goToNextElement);
    prevButton.addEventListener("click", goBack);
    
    function goToNextElement(){
        currentScrollLeft = slider.scrollLeft;
        slider.scrollLeft = currentScrollLeft + firstChildWidth + marginBetweenElement;
    }

    function goBack(){
        currentScrollLeft = slider.scrollLeft;
        slider.scrollLeft = currentScrollLeft - firstChildWidth - marginBetweenElement;
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-text-blocks"] && !Shopify.designMode) return;
  try {
    

 	const prevButton = document.querySelector("#icon-text-boxes-prev-btn");
    const nextButton = document.querySelector("#icon-text-boxes-next-btn");
    const slider = document.querySelector("#icon-text-boxes-container");

    let currentScrollLeft = slider.scrollLeft; 
    const firstChildWidth = slider.children[0].offsetWidth;
    const marginBetweenElement = 25;

    nextButton.addEventListener("click", goToNextElement);
    prevButton.addEventListener("click", goBack);
    
    function goToNextElement(){
        currentScrollLeft = slider.scrollLeft;
        slider.scrollLeft = currentScrollLeft + firstChildWidth + marginBetweenElement;
    }

    function goBack(){
        currentScrollLeft = slider.scrollLeft;
        slider.scrollLeft = currentScrollLeft - firstChildWidth - marginBetweenElement;
    }

  } catch(e) { console.error(e); }
})();
})();
